<div class="items-center gap-2 justify-center py-3 text-xs">
   <h2 class="uppercase">Debug info</h2>


   <h3>UI debug</h3>
   @for(feature of uiOnlyDebugFeatures; track feature) {
      <app-feature [feature]="feature" ></app-feature>
   }
   @if(debugFeatures.length) {
      <h3>Debug</h3>
      @for(feature of debugFeatures; track feature) {
         <app-feature [feature]="feature"></app-feature>
      }
      @if(showLogs) {
         <label for="debugInfo" class="italic">Logs:</label >
         <textarea id="debugInfo" class="w-full h-20 border" readonly>{{ debugInfo }}</textarea>
      }
      @else {
         <div class="italic">If 'logs' is checked, logs will be shown here.</div>
      }
   }
   @if (experimentalFeatures.length) {
      <h3>Experimental</h3>
      @for(feature of experimentalFeatures; track feature) {
         <app-feature [feature]="feature"></app-feature>
      }
   }
   @if(features.length) {
     <h3 class="border-b">Features</h3>
      @for(feature of features; track feature) {
         <app-feature [feature]="feature"></app-feature>
      }
   }


</div>